export default "__VITE_ASSET__6$T5KqSc__"